import image_concert from '/assets/images/event-categories/concert.jpg';
import image_concert_2x from '/assets/images/event-categories/concert@2x.jpg';
import image_standup from '/assets/images/event-categories/standup.jpg';
import image_standup_2x from '/assets/images/event-categories/standup@2x.jpg';
import image_festival from '/assets/images/event-categories/festival.jpg';
import image_festival_2x from '/assets/images/event-categories/festival@2x.jpg';
import image_workshop from '/assets/images/event-categories/workshop.jpg';
import image_workshop_2x from '/assets/images/event-categories/workshop@2x.jpg';
import image_dj from '/assets/images/event-categories/dj.jpg';
import image_dj_2x from '/assets/images/event-categories/dj@2x.jpg';
import image_pop from '/assets/images/event-categories/pop.jpg';
import image_pop_2x from '/assets/images/event-categories/pop@2x.jpg';
import image_party from '/assets/images/event-categories/party.jpg';
import image_party_2x from '/assets/images/event-categories/party@2x.jpg';
import image_rap from '/assets/images/event-categories/rap.jpg';
import image_rap_2x from '/assets/images/event-categories/rap@2x.jpg';

export const eventCategoriesData = [ // API Tarafından gelecek içerik (tahmini)
	{
		id: 1,
		title: 'Konser',
		searchTerm: 'Konser',
		image: image_concert,
		image2x: image_concert_2x,
	},
	{
		id: 2,
		title: 'Stand-up',
		searchTerm: 'Stand-up',
		image: image_standup,
		image2x: image_standup_2x,
	},
	{
		id: 3,
		title: 'Festival',
		searchTerm: 'Festival',
		image: image_festival,
		image2x: image_festival_2x,
	},
	{
		id: 4,
		title: 'Workshop',
		searchTerm: 'Workshop',
		image: image_workshop,
		image2x: image_workshop_2x,
	},
	{
		id: 5,
		title: 'DJ Performans',
		searchTerm: 'DJ Performans',
		image: image_dj,
		image2x: image_dj_2x,
	},
	{
		id: 7,
		title: 'Pop',
		searchTerm: 'Pop',
		image: image_pop,
		image2x: image_pop_2x,
	},
	{
		id: 7,
		title: 'Parti',
		searchTerm: 'Parti',
		image: image_party,
		image2x: image_party_2x,
	},
	{
		id: 8,
		title: 'Rap',
		searchTerm: 'Rap',
		image: image_rap,
		image2x: image_rap_2x,
	},
];

export default eventCategoriesData;